import { Box } from '@chakra-ui/react';
import { useCQMediaQuery } from '@laxmimanogna/code-quick-components';
import React from 'react';

const CQContainer = props => {
  const marginHorizontal = useCQMediaQuery({
    lg: '10%',
    md: '4%',
    sm: '2%',
  });

  return (
    <Box
      // width={'100%'}
      py={30}
      px={0}
      mx={marginHorizontal}
      {...props}
    />
  );
};

CQContainer.propTypes = {
  ...Box.propTypes,
};

export default CQContainer;
